/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";

/**
 * Form for rotating a tunneled MCP server source key
 */
export type RotateTunneledMcpServerKeyForm = {
  /**
   * The ID of the tunneled MCP server
   */
  id: string;
};

/** @internal */
export type RotateTunneledMcpServerKeyForm$Outbound = {
  id: string;
};

/** @internal */
export const RotateTunneledMcpServerKeyForm$outboundSchema: z.ZodMiniType<
  RotateTunneledMcpServerKeyForm$Outbound,
  RotateTunneledMcpServerKeyForm
> = z.object({
  id: z.string(),
});

export function rotateTunneledMcpServerKeyFormToJSON(
  rotateTunneledMcpServerKeyForm: RotateTunneledMcpServerKeyForm,
): string {
  return JSON.stringify(
    RotateTunneledMcpServerKeyForm$outboundSchema.parse(
      rotateTunneledMcpServerKeyForm,
    ),
  );
}
